"use client";
import { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { useBlogSearch } from '@/providers/blogSearchProvider';
import { Checkbox } from 'pretty-checkbox-react';

const SearchModule = ({ prechecked }) => {


    const { query, filters, setFilters, setQuery } = useBlogSearch();

    useEffect(() => {
        if (prechecked) {
            setFilters(prechecked);
        }
    }, [prechecked]);


    const handleSearch = (e) => {
        e.preventDefault();
    };

    const handleClick = value => {
        if (filters.includes(value)) {
            const newArray = filters.filter(element => element !== value);
            setFilters(newArray);
        } else {
            setFilters([...filters, value]);
        }
    }

    const handleChange = (e) => {
        const value = e?.target?.value;
        handleClick(value);
    }

    return (
        <section className={styles.searchModule}>
            <div className='container'>
                <div className={styles.searchModule__inner}>
                    <form onSubmit={handleSearch}>
                        <input 
                            placeholder='Search Resources'
                            type="text"
                            value={query}
                            onChange={(e) => setQuery(e?.target?.value)}
                            className={`${styles.searchModule__input} input`}
                        />
                        <button className={`${styles.searchModule__submit} button regular primary-fill`}>
                            Search
                        </button>
                    </form>
                </div>
                <nav className={styles.toggleBar}>
                    <Checkbox 
                        name="webinars" 
                        value="webinar"
                        checked={filters.includes('webinar')}
                        onChange={handleChange}
                    >
                        Webinars
                    </Checkbox>
                    <Checkbox 
                        name="success-stories" 
                        value="success-stories"
                        checked={filters.includes('success-stories')}
                        onChange={handleChange}
                    >
                        Success Stories
                    </Checkbox>
                    <Checkbox 
                        name="news" 
                        value="news"
                        checked={filters.includes('news')}
                        onChange={handleChange}
                    >
                        Company News
                    </Checkbox>
                    <Checkbox 
                        name="insights" 
                        value="insights"
                        checked={filters.includes('insights')}
                        onChange={handleChange}
                    >
                        Industry Insights
                    </Checkbox>
                    <Checkbox 
                        name="project-thrive" 
                        value="project-thrive"
                        checked={filters.includes('project-thrive')}
                        onChange={handleChange}
                    >
                        Project Thrive
                    </Checkbox>
                    <Checkbox 
                        name="podcast" 
                        value="podcast"
                        checked={filters.includes('podcast')}
                        onChange={handleChange}
                    >
                        Podcast
                    </Checkbox>
                </nav>
            </div>
        </section>
    );
}

export default SearchModule;
